/* eslint-disable react/no-danger */
import $ from 'jquery';
import React from 'react';
import { i18n } from '@mabinso-registry/module-commons';
import InfoUpload from './InfoUpload';
import auth from '../../utils/Auth';
import Globals from '../../utils/Globals';
import '../../css/textpages_screen.scss';
import '../../css/textpages_print.scss';

class Info extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            infoText: ''
        };
        this.getLicense();
        this.uploadSuccess = this.uploadSuccess.bind(this);
        this.buttonClose = this.buttonClose.bind(this);
        this.buttonPrint = this.buttonPrint.bind(this);
    }

    getLicense() {
        const comp = this;
        $.ajax({
            url: Globals.baseUrl + 'licence',
            dataType: 'json',
            type: 'GET',
            success: data => {
                if (data && data.infoText) {
                    comp.setState({ infoText: data.infoText });
                }
            },
            error() {
                console.error('AJAX ERROR');
            }
        });
    }

    uploadSuccess(data) {
        this.setState({ infoText: data.infoText });
    }

    buttonPrint() {
        window.print();
        console.log(this);
    }

    buttonClose() {
        window.history.back();
        console.log(this);
    }

    render() {
        return (
            <div className="infopage" style={{ textAlign: 'left' }}>
                <div id="document_top">
                    <p>{this.state.error}</p>
                </div>
                <div id="document_middle">
                    <h1>{i18n.t('licence.header')}</h1>
                    <p><strong>{i18n.t('licence.address.header')}</strong></p>
                    <p>maBinso software GmbH<br />Schellerdamm 16<br />21079 Hamburg<br /><a href="https://www.mabinso.com" target="_blank" rel="noopener noreferrer">www.mabinso.com</a></p>

                    <p>{i18n.t('licence.description.p1')}</p>
                    <p>{i18n.t('licence.description.p2')}</p>
                    <p dangerouslySetInnerHTML={{ __html: this.state.infoText }} />
                    <hr />
                    <p><strong>{i18n.t('licence.other.strong')}</strong></p>

                    <ul className="licenseul">
                        <li>
                            ALv2 (
                            <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank" rel="noopener noreferrer">
                                http://www.apache.org/licenses/LICENSE-2.0
                            </a>): <small>Asyncweb, Cglib, Commons Digester, Crossfilter, DC, Eclipse compiler, Ehcache, Ezmorph, Geronimo Servlets, Groovy, GSon, Jakarta commons components, Joda Time, JQtextile, JSR 107 Cache, Log4J, Log4Net, Netty, Snake YAML, Signpost, POI, Play!, Saiku, Flotr2</small>
                        </li>
                        <li>
                            ANTLR (
                            <a href="http://www.antlr.org/license.html" target="_blank" rel="noopener noreferrer">
                                http://www.antlr.org/license.html
                            </a>): <small>antlr</small>
                        </li>
                        <li>
                            BSD
                            (<a href="http://www.opensource.org/licenses/bsd-license.php" target="_blank" rel="noopener noreferrer">
                                http://www.opensource.org/licenses/bsd-license.php
                            </a>): <small>Imaging, Jamon, Jaxen, JRegex, Leaflet, leaflet-image, Simple Captcha</small>
                        </li>
                        <li>
                            BSD (3 clause)
                            (<a href="https://opensource.org/licenses/BSD-3-Clause" target="_blank" rel="noopener noreferrer">
                                https://opensource.org/licenses/BSD-3-Clause
                            </a>): <small>D3</small>
                        </li>
                        <li>
                            CPL (
                            <a href="http://www.opensource.org/licenses/cpl1.0.php" target="_blank" rel="noopener noreferrer">
                                http://www.opensource.org/licenses/cpl1.0.php
                            </a>):
                            <small>JUnit</small>
                        </li>
                        <li>
                            DOM4J (
                            <a href="http://www.dom4j.org/license.html" target="_blank" rel="noopener noreferrer">http://www.dom4j.org/license.html
                            </a>): <small>Dom4J</small>
                        </li>
                        <li>
                            EPL (
                            <a href="http://www.eclipse.org/legal/epl-v10.html" target="_blank" rel="noopener noreferrer">
                                http://www.eclipse.org/legal/epl-v10.html
                            </a>): <small>H2 Database, Oval, WikiText, Modrian</small>
                        </li>
                        <li>
                            ISC (
                            <a href="https://opensource.org/licenses/ISC" target="_blank" rel="noopener noreferrer">
                                https://opensource.org/licenses/ISC
                            </a>): <small>rapid.js</small>
                        </li>
                        <li>
                            LGPL (
                            <a href="http://www.gnu.org/licenses/lgpl.html" target="_blank" rel="noopener noreferrer">
                                http://www.gnu.org/licenses/lgpl.html
                            </a>): <small>c3p0, Hibernate, iText, Jasper Reports Library, JCommon, JFreeChart</small>
                        </li>
                        <li>
                            MIT (
                            <a href="http://www.opensource.org/licenses/mit-license.php" target="_blank" rel="noopener noreferrer">
                                http://www.opensource.org/licenses/mit-license.php
                            </a>): <small>
                                Axios, cypress, Font Awesome, html2canvas, immutability-helper, jest, jquery.contextmenu, jquery.form, jquery.i18n.properties, jquery.layout, jquery.scrollTo-min, jquery.simplemodal-min, jquery.tagsinput, jquery-ui-timepicker-addon, jquery.validationEngine, leaflet-extra-markers, leaflet-polylineoffset, leaflet.export, leaflet.tilelayer.colorfilter, MomentJS, mdn-polyfills, node-sass, query-string, React, react-app-polyfill, react-color, react-datepicker, react
                                modal, react-number-format, react-router-dom, react-select, react-simple-checkbox, react-svg-inline, react-table, resolve, sass-loader, SLF4J, Spy Memcached, sDashboard, style-loader, Underscore, url-loader, validator
                            </small>
                        </li>
                        <li>
                            MPL (
                            <a href="http://www.mozilla.org/MPL/MPL-1.1.html" target="_blank" rel="noopener noreferrer">
                                http://www.mozilla.org/MPL/MPL-1.1.html
                            </a>): <small>Javassist</small>
                        </li>
                    </ul>
                    <div className="buttonsfooter">
                        {auth.loggedIn() ? (
                            <InfoUpload success={this.uploadSuccess} />
                        ) : (
                            <div />
                        )}
                        <button href="#" onClick={this.buttonPrint} className="defaultButton buttonAutoFlat">{i18n.t('licence.button.print')}</button>
                        <button href="#" onClick={this.buttonClose} className="defaultButton buttonAutoFlat">{i18n.t('licence.button.close')}</button>
                    </div>
                </div>
                <div id="document_bottom" />
            </div>
        );
    }
}

export default Info;
